import {
  CountryID,
  CountryCode,
  LanguageId,
  LanguageCode,
  CurrencyCode,
  CurrencyCodeId,
  CountryPhoneCode,
} from "./enums";

/**
 * 国家默认信息
 */
export const countryMap = {
  // 印尼
  [CountryCode.ID]: {
    countryId: CountryID.ID,
    countryCode: CountryCode.ID,
    currencyCode: CurrencyCode.ID,
    currencyId: CurrencyCodeId[CurrencyCode.ID],
    languageCode: LanguageCode.in,
    languageId: LanguageId.in,
    phoneCode: CountryPhoneCode.ID,
    timeZone: 7,
    dateFormat: "DD/MM/YYYY",
  },
  // 马来
  [CountryCode.MY]: {
    countryId: CountryID.MY,
    countryCode: CountryCode.MY,
    currencyCode: CurrencyCode.MY,
    currencyId: CurrencyCodeId[CurrencyCode.MY],
    languageCode: LanguageCode.ms,
    languageId: LanguageId.ms,
    phoneCode: CountryPhoneCode.MY,
    timeZone: 8,
    dateFormat: "DD/MM/YYYY",
  },
  // 菲律宾
  [CountryCode.PH]: {
    countryId: CountryID.PH,
    countryCode: CountryCode.PH,
    currencyCode: CurrencyCode.PH,
    currencyId: CurrencyCodeId[CurrencyCode.PH],
    languageCode: LanguageCode.en,
    languageId: LanguageId.en,
    phoneCode: CountryPhoneCode.PH,
    timeZone: 8,
    dateFormat: "MM/DD/YYYY",
  },
  // 越南
  [CountryCode.VN]: {
    countryId: CountryID.VN,
    countryCode: CountryCode.VN,
    currencyCode: CurrencyCode.VN,
    currencyId: CurrencyCodeId[CurrencyCode.VN],
    languageCode: LanguageCode.vi,
    languageId: LanguageId.vi,
    phoneCode: CountryPhoneCode.VN,
    timeZone: 7,
    dateFormat: "DD/MM/YYYY",
  },
  // 中国
  [CountryCode.CHN]: {
    countryId: CountryID.CHN,
    countryCode: CountryCode.CHN,
    currencyCode: CurrencyCode.CHN,
    currencyId: CurrencyCodeId[CurrencyCode.CHN],
    languageCode: LanguageCode.zh,
    languageId: LanguageId.zh,
    phoneCode: CountryPhoneCode.CHN,
    timeZone: 8,
    dateFormat: "YYYY/MM/DD",
  },
  // 德国
  [CountryCode.DE]: {
    countryId: CountryID.DE,
    countryCode: CountryCode.DE,
    currencyCode: CurrencyCode.DE,
    currencyId: CurrencyCodeId[CurrencyCode.DE],
    languageCode: LanguageCode.de,
    languageId: LanguageId.de,
    phoneCode: CountryPhoneCode.DE,
    timeZone: 1,
    dateFormat: "DD/MM/YYYY",
  },
  // 西班牙
  [CountryCode.ES]: {
    countryId: CountryID.ES,
    countryCode: CountryCode.ES,
    currencyCode: CurrencyCode.ES,
    currencyId: CurrencyCodeId[CurrencyCode.ES],
    languageCode: LanguageCode.es,
    languageId: LanguageId.es,
    phoneCode: CountryPhoneCode.ES,
    timeZone: 1,
    dateFormat: "DD/MM/YYYY",
  },
  // 法国
  [CountryCode.FR]: {
    countryId: CountryID.FR,
    countryCode: CountryCode.FR,
    currencyCode: CurrencyCode.FR,
    currencyId: CurrencyCodeId[CurrencyCode.FR],
    languageCode: LanguageCode.fr,
    languageId: LanguageId.fr,
    phoneCode: CountryPhoneCode.FR,
    timeZone: 1,
    dateFormat: "DD/MM/YYYY",
  },
  // 意大利
  [CountryCode.IT]: {
    countryId: CountryID.IT,
    countryCode: CountryCode.IT,
    currencyCode: CurrencyCode.IT,
    currencyId: CurrencyCodeId[CurrencyCode.IT],
    languageCode: LanguageCode.it,
    languageId: LanguageId.it,
    phoneCode: CountryPhoneCode.IT,
    timeZone: 1,
    dateFormat: "DD/MM/YYYY",
  },
  // 比利时
  [CountryCode.BE]: {
    countryId: CountryID.BE,
    countryCode: CountryCode.BE,
    currencyCode: CurrencyCode.BE,
    currencyId: CurrencyCodeId[CurrencyCode.BE],
    languageCode: LanguageCode.fr,
    languageId: LanguageId.fr,
    phoneCode: CountryPhoneCode.BE,
    timeZone: 1,
    dateFormat: "DD/MM/YYYY",
  },
  // 波兰
  [CountryCode.PL]: {
    countryId: CountryID.PL,
    countryCode: CountryCode.PL,
    currencyCode: CurrencyCode.PL,
    currencyId: CurrencyCodeId[CurrencyCode.PL],
    languageCode: LanguageCode.pl,
    languageId: LanguageId.pl,
    phoneCode: CountryPhoneCode.PL,
    timeZone: 1,
    dateFormat: "DD/MM/YYYY",
  },
};
